export default "/packs/images/snow-2~0e883d1005b8486aae40c430b448f042.png";